var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _vm.news.length < 1
        ? _c("v-container", { attrs: { "grid-list-xl": "" } }, [
            _c("h3", { staticClass: "mt-7 text-center" }, [
              _vm._v("Es gibt zur Zeit keine Neuigkeiten"),
            ]),
          ])
        : _c(
            "v-container",
            { attrs: { "grid-list-xl": "" } },
            [
              _c("h2", { staticClass: "mt-5 mb-5" }, [_vm._v("Aktuelles")]),
              _c("div", { staticClass: "invisible all" }, [
                _vm._v(_vm._s(_vm.news)),
              ]),
              !_vm.loaded
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    _vm._l(3, function (n) {
                      return _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", lg4: "" } },
                        [
                          _c("v-skeleton-loader", {
                            staticClass: "mx-auto",
                            attrs: {
                              "max-width": "600",
                              type: "image, article",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    _vm._l(_vm.news, function (n) {
                      return _vm.news.length > 0
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", lg4: "" } },
                            [
                              _c("NewsCard", {
                                staticClass: "news-card pointer",
                                attrs: { "data-key": n.id, news: n },
                                nativeOn: {
                                  "&click": function ($event) {
                                    return _vm.gotoBeitrag(n)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", { staticClass: "mt-5" }, [
                              _vm._v("Es gibt zur Zeit keine Neuigkeiten"),
                            ]),
                          ])
                    }),
                    1
                  ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }